import Vue from "vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

if (!Vue.__graduationValidationInstalled) {
  Vue.component("ValidationProvider", ValidationProvider);
  Vue.component("ValidationObserver", ValidationObserver);
  Vue.__graduationValidationInstalled = true;
}
